<div class="box-multi" [class.box-error]="!valueArray.length && !readonly">
  <div *ngIf="!isAdditionMode" class="box-multi-header">
    <b>{{ 'DETAILS' | translate }}</b>
    <button *ngIf="!readonly" mat-flat-button color="primary" type="button"
            class="btn-add" (click)="enterAdditionMode()">
      <mat-icon>add_circle</mat-icon>
      {{ 'ADD' | translate }}
    </button>
  </div>
  <div *ngIf="!isAdditionMode && valueArray.length">
    <table mat-table [dataSource]="valueArray" [class.is-edited]="editedIndex !== null || isAdditionMode">

      <ng-container *ngFor="let control of innerForm.controls | keyvalue; let idx = index" [matColumnDef]="idx.toString()">
        <th mat-header-cell *matHeaderCellDef> {{displayedColumnNames[idx]}} </th>
        <td mat-cell *matCellDef="let element"> {{ getValue(element, control.key)}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns; let idx = index" [class.is-edited]="idx === editedIndex" (click)="editData(idx)"></tr>
    </table>
    <div class="mat-mdc-form-field-subscript-wrapper">
      <div class="mat-mdc-form-field-error-wrapper" *ngIf="shouldDisplayErrors()">
        <ng-content select="mat-error"></ng-content>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!isDisabled" [ngTemplateOutlet]="valueForm"></ng-container>
  <span *ngIf="!valueArray.length && !isAdditionMode"><i>{{ 'NO_DETAILS' | translate }}</i></span>

  <ng-template #valueForm>
    <div *ngIf="isAdditionMode">
      <ng-content select="dynamic-control"></ng-content>
      <div class="buttons-wrapper">
        <button *ngIf="editedIndex || editedIndex === 0" mat-flat-button color="primary" type="button" (click)="removeData()">{{ 'DELETE' | translate }}</button>
        <span class="flex-shrink"></span>
        <button mat-flat-button type="button" (click)="quitAdditionMode()">{{ 'CANCEL' | translate }}</button>
        <button mat-flat-button color="primary" type="button" (click)="addData()">{{ 'SAVE' | translate }}</button>
      </div>
    </div>
  </ng-template>
</div>
<div class="error-wrapper" *ngIf="!valueArray.length && !readonly">
  <div class="fake-error">{{ 'ADD_AT_LEAST_ONE_RECORD' | translate }}</div>
</div>

